export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6153.7da2d94e.jpg";